export default __webpack_public_path__ + "static/looking-09a58f5c9af93085c615d348bf5b1b04.png";